<template>
	<div
		:class="$style['skeleton-round']"
		:style="styles"
	/>
</template>

<script>
export default {
	name: 'SkeletonRound',
	props: {
		size: {
			type: String,
			default: '50px'
		},
		custom: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		styles () {
			const styles = {}
			styles.height = this.size
			styles.width = this.size

			return { ...styles, ...this.custom }
		}
	}
}
</script>

<style lang="scss" module>
	$from: getColorStatic(border-image);
	$to: scale-color($from, $lightness: -10%);

	.skeleton-round {
		display: flex;
		height: 50px;
		width: 50px;
		border-radius: 100%;
		background-color: getColor(chip-light);
		will-change: opacity;
		animation: pulse 1.2s ease-in-out infinite;

		@keyframes pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.5; }
		}
	}
</style>
